import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import {
    KPI_MATRIX_LIST,
    KPI_MATRIX_LIST_ITB,
    KPI_MATRIX_LIST_ANUAL_BASE_LINE,
    KPI_MATRIX_DETAIL,
    KPI_MATRIX_DATA_LIST,
    KPI_MATRIX_GRAPH_3MORE_LIST,
    KPI_MATRIX_GRAPH_BIDDER_CLAVES_LIST,
    KPI_MATRIX_GRAPH_PIE_LIST,
    KPI_MATRIX_GRAPH_BAR_LIST,
    KPI_MATRIX_TAG_SAVINGS_LIST,
    KPI_MATRIX_TOTAL_PZS_LIST,
    KPI_MATRIX_BIDDER_LIST,
    KPI_MATRIX_BIDDERMC_LIST,
    KPI_MATRIX_BIDDERMED2021_LIST,
    KPI_MATRIX_BIDDERMC2021_LIST,
    KPI_FUNNEL_LIST,
    KPI_FUNNELMC_LIST,
    KPI_EVALUATIONS,
    KPI_FUNNEL_PROCCESS_LIST
} from '../actions';

import {
    KpiMatrixListSuccess,
    KpiMatrixListError,
    KpiMatrixListITBSuccess,
    KpiMatrixListITBError,
    KpiMatrixListAnualBaseLineSuccess,
    KpiMatrixListAnualBaseLineError,
    KpiMatrixDetailSuccess,
    KpiMatrixDetailError,
    KpiMatrixDataListSuccess,
    KpiMatrixDataListError,
    KpiMatrixGraph3MoreListSuccess,
    KpiMatrixGraph3MoreListError,
    KpiMatrixGraphBidderClavesListSuccess,
    KpiMatrixGraphBidderClavesListError,
    KpiMatrixGraphPieListSuccess,
    KpiMatrixGraphPieListError,
    KpiMatrixGraphBarListSuccess,
    KpiMatrixGraphBarListError,
    KpiMatrixTagSavingsListSuccess,
    KpiMatrixTagSavingsListError,
    KpiMatrixTotalPzsListSuccess,
    KpiMatrixTotalPzsListError,
    KpiMatrixBidderListSuccess,
    KpiMatrixBidderListError,
    KpiMatrixBidderMcListSuccess,
    KpiMatrixBidderMcListError,
    KpiMatrixBidderMed2021ListSuccess,
    KpiMatrixBidderMed2021ListError,
    KpiMatrixBidderMc2021ListSuccess,
    KpiMatrixBidderMc2021ListError,
    KpiFunnelListSuccess,
    KpiFunnelListError,
    KpiFunnelMcListSuccess,
    KpiFunnelMcListError,
    KpiEvaluationsSuccess,
    KpiEvaluationsError,
    KpiFunnelProccessListSuccess,
    KpiFunnelProccessListError,
} from '../actions';

export function* watchKpiMatrixList() {
    yield takeEvery(KPI_MATRIX_LIST, onKpiMatrixList);
}

export function* watchKpiMatrixListITB() {
    yield takeEvery(KPI_MATRIX_LIST_ITB, onKpiMatrixListITB);
}

export function* watchKpiMatrixListAnualBaseLine() {
    yield takeEvery(KPI_MATRIX_LIST_ANUAL_BASE_LINE, onKpiMatrixListAnualBaseLine);
}

export function* watchKpiMatrixDetail() {
    yield takeEvery(KPI_MATRIX_DETAIL, onKpiMatrixDetail);
}

export function* watchKpiMatrixDataList() {
    yield takeEvery(KPI_MATRIX_DATA_LIST, onKpiMatrixDataList);
}

export function* watchKpiMatrixGraph3MoreList() {
    yield takeEvery(KPI_MATRIX_GRAPH_3MORE_LIST, onKpiMatrixGraph3MoreList);
}

export function* watchKpiMatrixGraphBidderClavesList() {
    yield takeEvery(KPI_MATRIX_GRAPH_BIDDER_CLAVES_LIST, onKpiMatrixGraphBidderClavesList);
}

export function* watchKpiMatrixGraphPieList() {
    yield takeEvery(KPI_MATRIX_GRAPH_PIE_LIST, onKpiMatrixGraphPieList);
}

export function* watchKpiMatrixGraphBarList() {
    yield takeEvery(KPI_MATRIX_GRAPH_BAR_LIST, onKpiMatrixGraphBarList);
}

export function* watchKpiMatrixTagSavingsList() {
    yield takeEvery(KPI_MATRIX_TAG_SAVINGS_LIST, onKpiMatrixTagSavingsList);
}

export function* watchKpiMatrixTotalPzsList() {
    yield takeEvery(KPI_MATRIX_TOTAL_PZS_LIST, onKpiMatrixTotalPzsList);
}

export function* watchKpiMatrixBidderList() {
    yield takeEvery(KPI_MATRIX_BIDDER_LIST, onKpiMatrixBidderList);
}

export function* watchKpiMatrixBidderMcList() {
    yield takeEvery(KPI_MATRIX_BIDDERMC_LIST, onKpiMatrixBidderMcList);
}

export function* watchKpiMatrixBidderMed2021List() {
    yield takeEvery(KPI_MATRIX_BIDDERMED2021_LIST, onKpiMatrixBidderMed2021List);
}

export function* watchKpiMatrixBidderMc2021List() {
    yield takeEvery(KPI_MATRIX_BIDDERMC2021_LIST, onKpiMatrixBidderMc2021List);
}

export function* watchKpiFunnelList() {
    yield takeEvery(KPI_FUNNEL_LIST, onKpiFunnelList);
}

export function* watchKpiFunnelMcList() {
    yield takeEvery(KPI_FUNNELMC_LIST, onKpiFunnelMcList);
}

export function* watchKpiEvaluations() {
    yield takeEvery(KPI_EVALUATIONS, onKpiEvaluations);
}

export function* watchKpiFunnelProccessList() {
    yield takeEvery(KPI_FUNNEL_PROCCESS_LIST, onKpiFunnelProccessList);
}

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onKpiMatrixListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiMatrix/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onKpiMatrixListITBAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiMatrix/listItb', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onKpiMatrixListAnualBaseLineAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiMatrix/listAnualBaseLine', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onKpiMatrixDetailAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiMatrix/detail', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onKpiMatrixDataListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiMatrix/listDataKpi', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onKpiMatrixGraph3MoreListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiMatrix/listGraph3moreKpi', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onKpiMatrixGraphBidderListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiMatrix/listGraphBidderClavesKpi', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onKpiMatrixGraphPieListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiMatrix/listGraphPieKpi', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onKpiMatrixGraphBarListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiMatrix/listGraphBarKpi', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onKpiMatrixTagSavingsListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiMatrix/listTagSavingsKpi', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onKpiMatrixTotalPzsListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiMatrix/listTotalPzs', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onKpiMatrixBidderListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiMatrix/listBidder', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onKpiMatrixBidderMcListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiMatrix/listBidderMc', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onKpiMatrixBidderMed2021ListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiMatrix/listBidderMed2021', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onKpiMatrixBidderMc2021ListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiMatrix/listBidderMc2021', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onKpiFunnelListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiMatrix/funnelClavesMed', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onKpiFunnelMcListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiMatrix/funnelClavesMC', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onKpiEvaluationsAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiMatrix/evaluations', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onKpiFunnelProccessListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiMatrix/funnelproccess', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};


function* onKpiMatrixList(data) {
    try {
        const response = yield call(onKpiMatrixListAsync, data.payload);
        yield put(KpiMatrixListSuccess(response.data));
    } catch (error) {
        yield put(KpiMatrixListError(error));
    }
}

function* onKpiMatrixListITB(data) {
    try {
        const response = yield call(onKpiMatrixListITBAsync, data.payload);
        yield put(KpiMatrixListITBSuccess(response.data));
    } catch (error) {
        yield put(KpiMatrixListITBError(error));
    }
}

function* onKpiMatrixListAnualBaseLine(data) {
    try {
        const response = yield call(onKpiMatrixListAnualBaseLineAsync, data.payload);
        yield put(KpiMatrixListAnualBaseLineSuccess(response.data));
    } catch (error) {
        yield put(KpiMatrixListAnualBaseLineError(error));
    }
}

function* onKpiMatrixDetail(data) {
    try {
        const response = yield call(onKpiMatrixDetailAsync, data.payload);
        yield put(KpiMatrixDetailSuccess(response.data.data));
    } catch (error) {
        yield put(KpiMatrixDetailError(error));
    }
}

function* onKpiMatrixGraph3MoreList(data) {
    try {
        const response = yield call(onKpiMatrixGraph3MoreListAsync, data.payload);
        yield put(KpiMatrixGraph3MoreListSuccess(response.data));
    } catch (error) {
        yield put(KpiMatrixGraph3MoreListError(error));
    }
}

function* onKpiMatrixDataList(data) {
    try {
        const response = yield call(onKpiMatrixDataListAsync, data.payload);
        yield put(KpiMatrixDataListSuccess(response.data));
    } catch (error) {
        yield put(KpiMatrixDataListError(error));
    }
}

function* onKpiMatrixGraphBidderClavesList(data) {
    try {
        const response = yield call(onKpiMatrixGraphBidderListAsync, data.payload);
        yield put(KpiMatrixGraphBidderClavesListSuccess(response.data));
    } catch (error) {
        yield put(KpiMatrixGraphBidderClavesListError(error));
    }
}

function* onKpiMatrixGraphPieList(data) {
    try {
        const response = yield call(onKpiMatrixGraphPieListAsync, data.payload);
        yield put(KpiMatrixGraphPieListSuccess(response.data));
    } catch (error) {
        yield put(KpiMatrixGraphPieListError(error));
    }
}

function* onKpiMatrixGraphBarList(data) {
    try {
        const response = yield call(onKpiMatrixGraphBarListAsync, data.payload);
        yield put(KpiMatrixGraphBarListSuccess(response.data));
    } catch (error) {
        yield put(KpiMatrixGraphBarListError(error));
    }
}

function* onKpiMatrixTagSavingsList(data) {
    try {
        const response = yield call(onKpiMatrixTagSavingsListAsync, data.payload);
        yield put(KpiMatrixTagSavingsListSuccess(response.data));
    } catch (error) {
        yield put(KpiMatrixTagSavingsListError(error));
    }
}

function* onKpiMatrixTotalPzsList(data) {
    try {
        const response = yield call(onKpiMatrixTotalPzsListAsync, data.payload);
        yield put(KpiMatrixTotalPzsListSuccess(response.data));
    } catch (error) {
        yield put(KpiMatrixTotalPzsListError(error));
    }
}

function* onKpiMatrixBidderList(data) {
    try {
        const response = yield call(onKpiMatrixBidderListAsync, data.payload);
        yield put(KpiMatrixBidderListSuccess(response.data));
    } catch (error) {
        yield put(KpiMatrixBidderListError(error));
    }
}

function* onKpiMatrixBidderMcList(data) {
    try {
        const response = yield call(onKpiMatrixBidderMcListAsync, data.payload);
        yield put(KpiMatrixBidderMcListSuccess(response.data));
    } catch (error) {
        yield put(KpiMatrixBidderMcListError(error));
    }
}

function* onKpiMatrixBidderMed2021List(data) {
    try {
        const response = yield call(onKpiMatrixBidderMed2021ListAsync, data.payload);
        yield put(KpiMatrixBidderMed2021ListSuccess(response.data));
    } catch (error) {
        yield put(KpiMatrixBidderMed2021ListError(error));
    }
}

function* onKpiMatrixBidderMc2021List(data) {
    try {
        const response = yield call(onKpiMatrixBidderMc2021ListAsync, data.payload);
        yield put(KpiMatrixBidderMc2021ListSuccess(response.data));
    } catch (error) {
        yield put(KpiMatrixBidderMc2021ListError(error));
    }
}


function* onKpiFunnelList(data) {
    try {
        const response = yield call(onKpiFunnelListAsync, data.payload);
        yield put(KpiFunnelListSuccess(response.data));
    } catch (error) {
        yield put(KpiFunnelListError(error));
    }
}


function* onKpiFunnelMcList(data) {
    try {
        const response = yield call(onKpiFunnelMcListAsync, data.payload);
        yield put(KpiFunnelMcListSuccess(response.data));
    } catch (error) {
        yield put(KpiFunnelMcListError(error));
    }
}

function* onKpiEvaluations(data) {
    try {
        const response = yield call(onKpiEvaluationsAsync, data.payload);
        yield put(KpiEvaluationsSuccess(response.data));
    } catch (error) {
        yield put(KpiEvaluationsError(error));
    }
}

function* onKpiFunnelProccessList(data) {
    try {
        const response = yield call(onKpiFunnelProccessListAsync, data.payload);
        yield put(KpiFunnelProccessListSuccess(response.data));
    } catch (error) {
        yield put(KpiFunnelProccessListError(error));
    }
}


export default function* rootSaga() {
    yield all([
        fork(watchKpiMatrixList),
        fork(watchKpiMatrixListITB),
        fork(watchKpiMatrixListAnualBaseLine),
        fork(watchKpiMatrixDetail),
        fork(watchKpiMatrixDataList),
        fork(watchKpiMatrixGraph3MoreList),
        fork(watchKpiMatrixGraphBidderClavesList),
        fork(watchKpiMatrixGraphPieList),
        fork(watchKpiMatrixGraphBarList),
        fork(watchKpiMatrixTagSavingsList),
        fork(watchKpiMatrixTotalPzsList),
        fork(watchKpiMatrixBidderList),
        fork(watchKpiMatrixBidderMcList),
        fork(watchKpiMatrixBidderMed2021List),
        fork(watchKpiMatrixBidderMc2021List),
        fork(watchKpiFunnelList),
        fork(watchKpiFunnelMcList),
        fork(watchKpiEvaluations),
        fork(watchKpiFunnelProccessList)
    ]);
}

